import { render, staticRenderFns } from "./CaseRequirementRelation.vue?vue&type=template&id=25771b30&scoped=true"
import script from "./CaseRequirementRelation.vue?vue&type=script&lang=js"
export * from "./CaseRequirementRelation.vue?vue&type=script&lang=js"
import style0 from "./CaseRequirementRelation.vue?vue&type=style&index=0&id=25771b30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25771b30",
  null
  
)

export default component.exports